<template>
  <div>
    <el-aside width="240px" class="aside_rolelist">
      <div class="asidelist">
        <div class="hd">
          <div>酒店</div>
          <div v-if="btnShow">
            <el-button
                class="header-icon el-icon-plus"
                type="primary"
                plain
                @click="add()"
            >添加
            </el-button>
          </div>
          <div style="float: right">
            <el-button
                class="header-icon el-icon-search"
                type="primary"
                plain
                @click="getProTypeId()">
              全部
            </el-button>
          </div>
        </div>
        <div class="role-container" id="rolelist">
          <el-tree :data="dataList" show-checkbox node-key="id"
                   :highlight-current="true"
                   ref="tree"
                   @node-click="nodebg"
                   :expand-on-click-node="false"
                   :props="defaultProps">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
              <span class="treefont">{{ node.label }}</span>
              <span class="bticon" v-show="btnShow">
                <el-dropdown>
                  <i class="el-icon-s-operation"></i>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                       <span style="color:#409EFF" class="el-icon-edit" @click="() => edit(data)">编辑</span>
                    </el-dropdown-item>
                    <el-dropdown-item>
                       <span style="color:#F56C6C" class="el-icon-delete" @click="() => remove(node, data)">删除</span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="(!data.disabled)">
                       <span style="color:#ff7f0d" class="el-icon-disable"
                             @click="() => disabled(node, data)">禁用</span>
                    </el-dropdown-item>
                    <el-dropdown-item v-else>
                       <span style="color:#00ff00" class="el-icon-enable" @click="() => enabled(node, data)">启用</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
            </span>
          </el-tree>
        </div>
        <div style="width: 100%;text-align: center">
          <el-popover
              placement="bottom"
              title="批量导入"
              width="220"
              trigger="click"
          >
            <div>
              <el-upload
                  class="upload-demo"
                  :action="action"
                  :auto-upload="false"
                  :on-change="uploadChange"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              >
                <el-button size="small" type="primary"
                >选择导入模板
                </el-button
                >
              </el-upload>
              <el-button
                  type="success"
                  @click="download"
                  plain
                  icon="el-icon-download"
                  class="down-template"
              >下载模板
              </el-button
              >
            </div>
            <p class="import-text">只能选择 .xls .xlsx 文件</p>
            <div>
              <el-button type="success" @click="importData"
              >开始导入
              </el-button
              >
            </div>
            <el-button
                type="primary"
                plain
                icon="el-icon-upload2"
                slot="reference"
            >导入
            </el-button
            >
          </el-popover>
        </div>
      </div>
      <el-dialog :title="title" width="30%"
                 :visible.sync="dialogVisible"
                 :before-close="handleDialogClose">
        <el-form :model="formData" ref="formData" :rules="rules" label-width="120px">
          <el-form-item label="酒店名称" prop="name">
            <el-input v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item label="酒店地址" prop="address">
            <el-input v-model="formData.address"></el-input>
          </el-form-item>
          <el-form-item label="酒店类型" prop="type">
            <el-input v-model="formData.type"></el-input>
          </el-form-item>
          <el-form-item label="禁用/启用" prop="disabled">
            <el-radio-group v-model="formData.disabled">
              <el-radio :label="true">禁用</el-radio>
              <el-radio :label="false">启用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleDialogClose">取 消</el-button>
          <el-button type="primary" @click="addsaveClick('formData')">确 定</el-button>
        </span>
      </el-dialog>
    </el-aside>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //角色列表数据
      rules: {
        name: [{required: true, message: "酒店名称不能为空", trigger: "blur"}],
        // address: [{required: true, message: "酒店地址不能为空", trigger: "blur"}],
        // type: [{required: true, message: "酒店类型不能为空", trigger: "blur"}],
      },
      dataList: [],
      defaultProps: {
        label: "name"
      },
      dialogVisible: false,
      formData: {
        name: "",
        address: "",
        type: "",
        disabled: false,
        projectId: localStorage.getItem("project_Id"),
      },
      action: localStorage.getItem("url") + "/Upload/File",
      idx: -1,
      btnShow: true,
      ProjectHotel_Id: "",
      projectId: localStorage.getItem("project_Id"),
      title: '添加项目酒店'
    };
  },
  created() {
    this.router(this.$route.path)
    this.getData();
  },
  watch: {
    'idx': function () {
      if (this.idx == -1) {
        this.title = '添加项目酒店'
      } else {
        this.title = '编辑项目酒店'
      }
    }
  },
  methods: {
    uploadChange(file, fileList) {
      let inputDOM = this.$refs.inputer; // 通过DOM取文件数据

      this.file = event.currentTarget.files[0];
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;

      var reader = new FileReader(); //if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64",
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
            });
          } // outdata就是你想要的东西 excel导入的数据
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); // excel 数据再处理
          let ar = [];
          outdata.map((v) => {
            let obj = {};
            obj.name = v.酒店名称;
            obj.type = v.酒店类型;
            obj.address = v.酒店地址;
            obj.disabled = false;
            ar.push(obj);
          });
          localStorage.setItem("attr", JSON.stringify(ar));
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    download() {
      var url = localStorage.getItem("url");
      if (url.lastIndexOf("/api") == url.indexOf("/api")) {
        window.open(url.replace("/api", "/") + "/data/酒店.xlsx");
      } else {
        window.open(
            url.substring(0, url.lastIndexOf("/api")) + "/data/酒店.xlsx"
        );
      }
    },
    importData() {
      this.attr = JSON.parse(localStorage.getItem("attr"));
      if (this.attr && this.attr.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.$axios
            .put("/ProjectHotel/batchAdd/" + this.projectId, this.attr)
            .then((res) => {
              if (res.data.hasError == false) {
                loading.close();
                localStorage.setItem("attr", null);
                this.getData();
                this.$message.success(res.data.message);
              } else {
                this.$message.error(res.data.message);
                loading.close();
              }
            })
            .catch(function () {
              loading.close();
            });
      } else {
        this.$message.error("没有可上传的数据");
      }
    },
    nodebg(data) {
      this.$emit('getPTypeId', data.projectHotelId);
    },
    router(val) {
      if (val == '/project-manage') {
        this.btnShow = false
      } else if (val == '/project-type') {
        this.btnShow = true
      }
    },
    getData() {
      this.$axios.get('/ProjectHotel/Project/' + this.projectId).then(res => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data]
        }
      })
    },
    //添加角色
    addsaveClick(formData) {
      this.$refs[formData].validate(valid => {
        if (valid) {
          if (this.idx == -1) {
            this.$axios.post('/ProjectHotel/', this.formData)
                .then(res => {
                  if (res.data.hasError == false) {
                    this.$message({type: "success", message: "添加成功!"});
                    this.getData();
                  } else {
                    this.$message.error(res.data.message);
                  }
                })
          } else {
            this.$axios.put(`/ProjectHotel/${this.idx}`, this.formData)
                .then(res => {
                  if (res.data.hasError == false) {
                    this.$message({type: "success", message: "修改成功!"});
                    this.getData();
                    this.formData.name = ""
                    this.idx = -1
                  } else {
                    this.$message.error(res.data.message);
                  }
                })
          }
          this.dialogVisible = false;
        }
      })
    },
    add() {
      this.dialogVisible = true;
      this.formData.name = "";
      this.formData.address = "";
      this.formData.type = "";
      this.formData.disabled = 0;
      this.idx = -1;
    },
    edit(data) {
      this.dialogVisible = true;
      this.formData.name = data.name;
      this.formData.address = data.address;
      this.formData.type = data.type;
      this.formData.disabled = data.disabled;
      this.idx = data.projectHotelId;
    },
    remove(node, data) {
      this.$confirm("是否确认删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
        // type: 'warning'
      }).then(() => {
        this.$axios.delete(`/ProjectHotel/${data.projectHotelId}`)
            .then(res => {
              if (res.data.hasError) {
                this.$message.error(res.data.message);
              } else {
                this.$message({type: "success", message: "删除成功!"});
                //刷新
                this.getData();
              }
            });
      })
          .catch(() => {
            this.$message({type: "info", message: "已取消删除"});
          });
    },
    disabled(node, data) {
      this.$confirm("是否确认禁用？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
        // type: 'warning'
      }).then(() => {
        this.$axios.put(`/ProjectHotel/Disabled/${data.projectHotelId}`)
            .then(res => {
              if (res.data.hasError) {
                this.$message.error(res.data.message);
              } else {
                this.$message({type: "success", message: "禁用成功!"});
                //刷新
                this.getData();
              }
            });
      })
          .catch(() => {
            this.$message({type: "info", message: "已取消禁用"});
          });
    },
    enabled(node, data) {
      this.$confirm("是否确认启用？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
        // type: 'warning'
      }).then(() => {
        this.$axios.put(`/ProjectHotel/Enabled/${data.projectHotelId}`)
            .then(res => {
              if (res.data.hasError) {
                this.$message.error(res.data.message);
              } else {
                this.$message({type: "success", message: "启用成功!"});
                //刷新
                this.getData();
              }
            });
      })
          .catch(() => {
            this.$message({type: "info", message: "已取消启用"});
          });
    },
    handleDialogClose() {
      this.idx = -1
      this.formData.name = ''
      this.dialogVisible = false
    },
    getProTypeId(data) {
      if (data) {
        this.$emit('getPTypeId', data.projectHotelId);
      } else {
        this.$emit('getPTypeId', 0);
      }
    }
  }
};
</script>
<style lang="scss" scope>
.header-icon {
  float: none;
}

.file-up {
  width: 100px;
  position: absolute;
  height: 32px;
  opacity: 0;
}

.asidelist {
  background-color: #fff;
  border-radius: 5px;
  width: 100%;
  height: 100%;

  .hd {
    height: 60px;
    border-bottom: 1px solid #ebeef5;
    box-sizing: border-box;
    padding: 0 10px;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
  }

  .el-tree-node__expand-icon.is-leaf {
    color: f2f2f2;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 18px;
  }

  .el-checkbox__inner {
    width: 0;
  }

  .el-tree-node__content {
    height: 40px;
  }

}

.aside_rolelist {
  height: 100%;
}
</style>